export default __webpack_public_path__ + "static/media/pic.a06d78c4.PNG";